import React from "react";
import { createFileRoute } from "@tanstack/react-router";
//
import { userInfoQueryOpts } from "src/services/apiQueries/userQueries";
import { queryClient } from "@config/tanstack/tanstackQuery";
//
import { SimpleTable } from "@components/simple-table";

const MyComponent: React.FC = () => {
  const {
    account,
    notification_preferences: notifPrefs,
    ...userInfo
  } = Route.useLoaderData();

  return (
    <div>
      <SimpleTable title="User Info" data={userInfo} />
      <SimpleTable title="Account" data={{ ...account }} />
      {notifPrefs ? (
        <SimpleTable
          title="Notification Preferences"
          data={{ ...notifPrefs }}
        />
      ) : null}
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/welcome")({
  component: MyComponent,
  loader: async () => {
    const resp = await queryClient.ensureQueryData(userInfoQueryOpts());
    return resp;
  },
});
